import { render, staticRenderFns } from "./PdvPrintDialog.vue?vue&type=template&id=36d40852"
import script from "./PdvPrintDialog.vue?vue&type=script&lang=js"
export * from "./PdvPrintDialog.vue?vue&type=script&lang=js"
import style0 from "./PdvPrintDialog.vue?vue&type=style&index=0&id=36d40852&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports